<template>
  <div class="row top-bar" v-if="permission && permission.version === '5'" aria-label="header">
    <button type="button" class="skip-header-button" tabindex="0" aria-label="Skip to page content" @click="skipToPageContent">Skip to page Content</button>

    <div class="col-4 logo_container">
      <div class="d-none" v-if="institutionTheme.fontFamily">
        <font-picker :api-key="apiKey" :active-font="institutionTheme.fontFamily" :options="{name: 'srf'}"></font-picker>
      </div>

      <div class="" v-if="!isShowingTermAndCondition">
        <div class="main-menu-bar" v-if="showSecondaryNavBar">

          <div v-if="inPersonateMode" class="stop-acting-user">
            Acting as {{username}}
            <b-btn class="btn" aria-label="stop acting as User" @click="stopActing">exit</b-btn>
          </div>

          <div class="row">

            <template v-if="permission.userPermission.studentHomeView || permission.userPermission.employerAdminHomeView || permission.userPermission.advisorHomeView || permission.userPermission.recruiterHomeView || permission.userPermission.prospectiveStudentHomeView || permission.userPermission.admittedStudentHomeView || permission.userPermission.widgetAdminHomeView">
              <template v-if="permission.userPermission.studentHomeView && isLearnerDashboardEnabled">
                <div class="col-12">
                  <b-dropdown no-caret class="navigation-menu" aria-label="main menu">
                    <template slot="button-content">
                      <span title="Main Menu" id="mainMenuDropdownButton">
                        <span class="icon-bar"><span class="visibility_hide">C</span></span>
                        <span class="icon-bar"><span class="visibility_hide">C</span></span>
                        <span class="icon-bar"><span class="visibility_hide">C</span></span>
                      </span>
                    </template>

                    <div class="links new_menu" aria-labelledby="mainMenuDropdownButton">
                      <b-dropdown-item @click="partnerHomePage" class="lnk_menu lnk_menu_footer" :aria-label="$t('homeNavAria')" v-if="(this.institution.partnerHomeUrl && this.institution.partnerHomeUrl.length>10)">
                        <span class="ic_container">
                          <span class="ic icon-home"></span>
                        </span>
                        <span class="lnk_txt">{{ $t('home') }}</span>
                      </b-dropdown-item>
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'modernDashboard'}" :aria-label="$t('homeNavAria')" v-else-if="(this.institution.learnerDashboard && (this.institution.learnerDashboard.indexOf('modern')!=-1))">
                        <span class="ic_container">
                          <span class="ic icon-home"></span>
                        </span>
                        <span class="lnk_txt">{{ $t('myHome') }}</span>
                      </b-dropdown-item>
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'learnerDashboard'}" :aria-label="$t('homeNavAria')" v-else>
                        <span class="ic_container">
                          <span class="ic icon-home"></span>
                        </span>
                        <span class="lnk_txt">{{ $t('myHome') }}</span>
                      </b-dropdown-item>
                      <b-dropdown-item v-if="institutionCount > 1" class="lnk_menu lnk_menu_footer" :to="{name: 'InstitutionSwitch'}" :aria-label="$t('myInstitutionsNavAria')">
                          <span class="ic_container">
                            <span class="ic ico-degreeProgram ico-program"></span>
                          </span>
                          <span class="lnk_txt">{{ $t('myInstitutions') }}</span>
                        </b-dropdown-item>
                        <template v-if="isShowProgramsEnabled">
                           <template v-for="(pg, index) in learnerEnrollmentData" >
                              <b-dropdown-item class="lnk_menu lnk_menu_footer" @click="showProgramHome(pg.programCode)" :aria-label="pg.programTitle" >
                                <span class="lnk_txt">{{pg.programTitle}}</span>
                              </b-dropdown-item>
                           </template>
                        </template>

                      <template v-if="isMyProgressEnabled && !isCapsico">
                        <template v-if="learnerEnrollmentData.length > 1">
                          <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'learnerProgramList'}" :aria-label="$t('myProgressNavAria')">
                            <span class="ic_container">
                              <span class="ic ico-degreeProgram ico-progress"></span>
                            </span>
                            <span class="lnk_txt">
                              {{ $t('myProgress') }}
                            </span>
                          </b-dropdown-item>
                        </template>
                        <template v-if="learnerEnrollmentData.length === 1">
                          <b-dropdown-item class="lnk_menu lnk_menu_footer" @click="navigateToLearnerProgram" :aria-label="'My' + exploreProgramsLabel">
                            <span class="ic_container">
                              <span class="ic ico-degreeProgram ico-progress"></span>
                            </span>
                            <span class="lnk_txt">{{ $t('myProgress') }}</span>
                          </b-dropdown-item>
                        </template>
                      </template>
                      <template v-if="isJobBoardEnabled">
                        <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'myJobApplications'}" :aria-label="$t('myJobApplicationsNavAria')">
                          <span class="ic_container">
                            <span class="ic ic2_job-application"></span>
                          </span>
                          <span class="lnk_txt">
                            {{ $t('myJobApplications') }}
                          </span>
                        </b-dropdown-item>
                      </template>
                      <template v-if="isCalendarEnabled">
                        <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'calendarEventList'}" :aria-label="$t('calendarNavAria')">
                          <span class="ic_container">
                            <span class="ic ic2_calendar"></span>
                          </span>
                          <span class="lnk_txt">
                            {{ $t('calendar') }}
                          </span>
                        </b-dropdown-item>
                      </template>
                      <template v-if="isAcceptPaymentsEnabled && !isCapsico">
                        <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'purchases'}" :aria-label="$t('myPurchasesNavAria')">
                          <span class="ic_container">
                            <span class="ic ic22-dateRange"></span>
                          </span>
                          <span class="lnk_txt">
                            {{ $t('myPurchases') }}
                          </span>
                        </b-dropdown-item>
                      </template>
                      <template v-if="isExplorePackageEnabled && !isCapsico">
                        <span class="menu_sub_hd">{{ $t('hdExplore') }}</span>
                        <b-dropdown-item v-if="isExploreCareerEnabled" class="lnk_menu lnk_menu_footer" :to="{name: 'exploreCareerResults'}" aria-label="careersExploreNavAria">
                          <span class="ic_container">
                            <span class="ic ico-career"></span>
                          </span>
                          <span class="lnk_txt">{{ exploreCareerLabel }}</span>
                        </b-dropdown-item>
                        <b-dropdown-item :to="{ name: 'employerBoard' }" class="lnk_menu lnk_menu_footer" aria-label="employer board" v-if="isEmployerBoardEnabled">
                          <span class="ic_container">
                              <span class="ic ico-employer"></span>
                          </span>
                          <span class="lnk_txt">
                            {{getEmployerBoardLabel}} 
                          </span>
                        </b-dropdown-item>
                        <b-dropdown-item v-if="isJobBoardEnabled" :to="{ name: 'jobBoard', params: { reload: true} }" class="lnk_menu lnk_menu_footer" :aria-label="getJobBoardLabel">
                          <span class="ic_container">
                              <span class="ic ic2_job-briefcase"></span>
                          </span>
                          <span class="lnk_txt">
                            {{ getJobBoardLabel }}
                          </span>
                        </b-dropdown-item>
                        <b-dropdown-item v-if="isExploreProgramEnabled" class="lnk_menu lnk_menu_footer" :to="{name: 'exploreProgramGuideResults'}" :aria-label="exploreProgramLabel">
                          <span class="ic_container">
                            <span class="ic ico-degreeProgram ico-program"></span>
                          </span>
                          <span class="lnk_txt">{{ exploreProgramLabel }}</span>
                        </b-dropdown-item>
                      </template>
                      <template v-if="links.length>0">
                        <span class="menu_sub_hd">{{getQuickLinksLabel()}}</span>
                        <b-dropdown-item v-for="(link, i) in links" class="lnk_menu lnk_menu_footer" @click="launchQuickLink(link.url)" :aria-label="link.title" v-if="i < showLinkSize">
                          <span class="ic_container">
                            <span class="ic ic24-link"></span>
                          </span>
                          <span class="lnk_txt">{{link.title}}</span>
                        </b-dropdown-item>
                        <span class="menu_foot" v-if="showLinkSize > 0">
                          <a href="javascript:void(0)" class="foot_link" v-if="links.length > showLinkSize" @click="showAllLink" :aria-label="'show more ' + getQuickLinksLabel()">
                            {{ $t('more', 'more') }}
                          </a>
                          <a href="javascript:void(0)" class="foot_link" v-if="showLinkSize > 2 && links.length <= showLinkSize" @click="showLimitedLink" :aria-label="'show limited ' + getQuickLinksLabel()">
                            {{ $t('less', 'less') }}
                          </a>
                        </span>
                      </template>

                    </div>
                  </b-dropdown>
                </div>
              </template>
              <template v-else-if="(permission.userPermission.advisorHomeView || permission.userPermission.recruiterHomeView ) && isNamedQueriesEnabled">
                <b-dropdown variant="link" no-caret class="navigation-menu" aria-label="main menu">
                  <template slot="button-content">
                    <span class="icon-bar"><span class="visibility_hide">C</span></span>
                    <span class="icon-bar"><span class="visibility_hide">C</span></span>
                    <span class="icon-bar"><span class="visibility_hide">C</span></span>
                  </template>
                  <div class="links_container">
                    <div class="links new_menu">
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: dashboardName}" :aria-label="$t('myHomeNavAria')">
                        <span class="ic_container">
                          <span class="ic icon-home"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ $t('myHome') }}
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item v-if="institutionCount > 1" class="lnk_menu lnk_menu_footer" :to="{name: 'InstitutionSwitch'}" :aria-label="$t('myInstitutions')">
                          <span class="ic_container">
                            <span class="ic ico-degreeProgram ico-program"></span>
                          </span>
                          <span class="lnk_txt">
                            {{ $t('myInstitutions') }}
                          </span>
                      </b-dropdown-item>

                      <template v-if="isCalendarEnabled">
                        <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'calendarEventList'}" :aria-label="$t('calendar')">
                          <span class="ic_container">
                            <span class="ic ic22-dateRange"></span>
                          </span>
                          <span class="lnk_txt">
                            {{ $t('calendar') }}
                          </span>
                        </b-dropdown-item>
                      </template>
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'tagList'}" :aria-label="$t('tagConfiguration')" v-if=" permission.menuItemPermission.canAdministerTagging">
                        <span class="ic_container">
                          <span class="ic ic-tag tagging-icon"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ $t('tagConfiguration') }}
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'programGuideList'}" :aria-label="exploreProgramsLabel" v-if="isAdvisor">
                        <span class="ic_container">
                          <span class="ic ic-tag tagging-icon"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ exploreProgramsLabel }} Guide
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'recruiterReport'}" :aria-label="$t('reports')">
                        <span class="ic_container">
                          <span class="ic ic22-reports"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ $t('reports') }}
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item v-if="isJobBoardEnabled" :to="{ name: 'jobBoard', params: { reload: true} }" class="lnk_menu lnk_menu_footer" :aria-label="getJobBoardLabel">
                        <span class="ic ic2_job-briefcase"></span>
                        <span class="lnk_txt">
                          {{ getJobBoardLabel }}
                        </span>
                      </b-dropdown-item>
                    </div>
                  </div>
                </b-dropdown>
              </template>
              <template v-else-if="permission.userPermission.employerAdminHomeView">
                <b-dropdown variant="link" no-caret class="navigation-menu" aria-label="main menu">
                  <template slot="button-content">
                    <span class="icon-bar"><span class="visibility_hide">C</span></span>
                    <span class="icon-bar"><span class="visibility_hide">C</span></span>
                    <span class="icon-bar"><span class="visibility_hide">C</span></span>
                  </template>
                  <div class="links_container">
                    <div class="links new_menu">
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: dashboardName}" :aria-label="$t('myHomeNavAria')">
                        <span class="ic_container">
                          <span class="ic icon-home"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ $t('myHome') }}
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item v-if="institutionCount > 1" class="lnk_menu lnk_menu_footer" :to="{name: 'InstitutionSwitch'}" :aria-label="$t('myInstitutions')">
                          <span class="ic_container">
                            <span class="ic ico-degreeProgram ico-program"></span>
                          </span>
                          <span class="lnk_txt">
                            {{ $t('myInstitutions') }}
                          </span>
                      </b-dropdown-item>

                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'employerDetails', params: { uuid: institutionUuid } }" :aria-label="$t('employerDetailsNavAria')">
                        <span class="ic_container">
                          <span class="ic ico-employer"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ $t('employerDetails') }}
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'manageJobs' }" :aria-label="$t('hdManage') + ' ' + $t('jobs')">
                        <span class="ic_container">
                          <span class="ic ic2_job-briefcase"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ $t('hdManage') }} {{ $t('jobs') }}
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'jobCreate'}" :aria-label="$t('create')">
                        <span class="ic_container">
                          <span class="ic ic2_job-briefcase"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ $t('create') }} {{ $t('job') }}
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'jobUpload'}" :aria-label="$t('upload')">
                        <span class="ic_container">
                          <span class="ic ic2_job-briefcase"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ $t('upload') }} {{ $t('job') }}
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'manageEmployerInstitutions'}" :aria-label="$t('institution')">
                        <span class="ic_container">
                          <span class="ic ic-inst"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ $t('educationalInstitutions') }}
                        </span>
                      </b-dropdown-item>

                    </div>
                  </div>
                </b-dropdown>
              </template>

              <template v-else-if="permission.userPermission.widgetAdminHomeView && isSelfRegistrationEnabled">
                <b-dropdown variant="link" no-caret class="navigation-menu" aria-label="main menu">
                  <template slot="button-content">
                    <span class="icon-bar"><span class="visibility_hide">C</span></span>
                    <span class="icon-bar"><span class="visibility_hide">C</span></span>
                    <span class="icon-bar"><span class="visibility_hide">C</span></span>
                  </template>
                  <div class="links_container">
                    <div class="links new_menu">
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: dashboardName}" :aria-label="$t('widgetConfiguration')">
                        <span class="ic_container">
                          <span class="ic icon-home"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ $t('widgetConfiguration') }}
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'selfRegistrationConfiguration', params: {uuid: this.institutionUuid}}" :aria-label="$t('selfRegistrationConfiguration')">
                        <span class="ic_container">
                          <span class="ic ic22-dateRange"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ $t('selfRegistrationConfiguration') }}
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'exploreIntro'}" :aria-label="$t('explore')" v-if="isExplorePackageEnabled">
                        <span class="ic_container">
                          <span class="ic icon-explore ace_sec"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ $t('explore') }}
                        </span>
                      </b-dropdown-item>
                    </div>
                  </div>
                </b-dropdown>
              </template>
              <template v-else>
                <div class="student-menu" id="tourStep_0" v-if="!isClearlyNextPackageEnabled">
                  <b-link tabindex="0" class="ic icon-home ace_sec" :to="{ name: dashboardName}" :aria-label="$t('home')">
                  </b-link>
                  <b-link tabindex="0" v-if="isExplorePackageEnabled" class="ic icon-explore ace_sec" :to="{ name: 'exploreIntro', params: { reload: true} }" :aria-label="$t('explore')">
                  </b-link>
                </div>
              </template>
            </template>
            <template v-else-if="isCustomAdmin">
                <b-dropdown variant="link" no-caret class="navigation-menu">
                  <template slot="button-content">
                    <span class="icon-bar"><span class="visibility_hide">C</span></span>
                    <span class="icon-bar"><span class="visibility_hide">C</span></span>
                    <span class="icon-bar"><span class="visibility_hide">C</span></span>
                  </template>
                  <div class="links_container">
                    <div class="links new_menu" v-if="!isSupervisor">
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'InstitutionSettings' , params: { uuid: this.institutionUuid,configName:'about' }}" :aria-label="$t('institutionConfiguration')">
                        <span class="ic_container">
                          <span class="ic icon-home"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ $t('institutionConfiguration') }}
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'exploreIntro'}" :aria-label="$t('explore')" v-if="isExplorePackageEnabled">
                        <span class="ic_container">
                          <span class="ic icon-explore ace_sec"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ $t('explore') }}
                        </span>
                      </b-dropdown-item>
                    </div>
                    <div class="links new_menu" v-else>
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'supervisorDashboard' , params: { uuid: this.institutionUuid,configName:'about' }}" :aria-label="$t('dashboard')">
                        <span class="ic_container">
                          <span class="ic icon-home"></span>
                        </span>
                        <span class="lnk_txt">
                          {{ $t('dashboard') }}
                        </span>
                      </b-dropdown-item>
                    </div>
                  </div>
                </b-dropdown>
            </template>
            <template v-else>
              <b-dropdown variant="link" no-caret class="navigation-menu" aria-label="main menu">
                <template slot="button-content">
                  <span class="icon-bar"><span class="visibility_hide">C</span></span>
                  <span class="icon-bar"><span class="visibility_hide">C</span></span>
                  <span class="icon-bar"><span class="visibility_hide">C</span></span>
                </template>

                <div class="links_container">
                  <div class="links_block" v-if="permission.menuItemPermission && permission.menuItemPermission.canAdminister">
                    <div class="header">
                      {{ $t('hdAdmin') }}
                    </div>
                    <div class="links">
                      <template v-if="permission.menuItemPermission.canAdminister">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'institutionSummary', params: { uuid: this.institutionUuid }}" :aria-label="$t('institution')">
                          {{ $t('institution') }}
                        </b-dropdown-item>
                      </template>

                      <template v-if="institutionCount > 1">
                        <b-dropdown-item :to="{ name: 'ChildInstitutionSwitch' , params: { uuid: this.institutionUuid }}" :aria-label="$t('myInstitution')">
                          {{ $t('myInstitution') }}
                        </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canAdministerUser">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'listUsers' }" :aria-label="$t('user')">
                          {{ $t('user') }}
                        </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadCareer">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'careerList' }" :aria-label="$t('career')">
                          {{ $t('career') }}
                        </b-dropdown-item>
                      </template>
                      <template v-if="permission.menuItemPermission.canAdministerFolder">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'manageJobs' }" :aria-label="$t('job')">
                          {{ $t('job') }}
                        </b-dropdown-item>
                      </template>
                      <template v-if="permission.menuItemPermission.canAdministerFolder && institution.orgType!=='EMPLOYER'">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'manageInstitutionEmployers' }" :aria-label="$t('employer')">
                          {{ $t('employer') }}
                        </b-dropdown-item>
                      </template>
                      <template v-if="permission.menuItemPermission.canAdministerFolder && institution.orgType==='EMPLOYER'">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'manageEmployerInstitutions' }" :aria-label="$t('educationalInstitutions')">
                          {{ $t('educationalInstitutions') }}
                        </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canAdministerFolder">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'folderList' }" :aria-label="$t('folder')">
                          {{ $t('folder') }}
                        </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canAdministerCourse">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'courseList' }" :aria-label="$t('course')">
                            {{ $t('course') }}
                          </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canAdministerCourse">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'microCompetencyList' }" :aria-label="$t('microCompetency')">
                            {{ $t('microCompetency') }}
                          </b-dropdown-item>
                      </template>
                      <template v-if="permission.menuItemPermission.canUploadCatalog">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'catalogList' }" :aria-label="$t('courseCatalog')">
                            {{ $t('courseCatalog') }}
                          </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canAdministerTool">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'toolList' }" :aria-label="$t('LTITool')">
                          {{ $t('LTITool') }}
                        </b-dropdown-item>
                      </template>

                      <!-- TAGGING -->
                      <template v-if="permission.menuItemPermission.canAdministerTagging">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'tagList' }" :aria-label="$t('tagging')">
                          {{ $t('tagging') }}
                        </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canAdministerChannel">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'listChannels' }" :aria-label="$t('channel')">
                          {{ $t('channel') }}
                        </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canAdministerConnector">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'connectorList' }" :aria-label="$t('connector')">
                          {{ $t('connector') }}
                        </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canAdministerQuicklink">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'quickLinkList' }" :aria-label="$t('quickLink')">
                          {{ $t('quickLink') }}
                        </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadMajorMinor">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'majorMinorList' }" :aria-label="$t('majorMinor')">
                          {{ $t('majorMinor') }}
                        </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canAdministerProgramGuide">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'programGuideList' }" aria-label="program guide">
                          {{exploreProgramsLabel}} Guide
                        </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canAdministerCompetencyTree">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'competencyTreeList' }" :aria-label="$t('competencyTree')">
                          {{ $t('competencyTree') }}
                        </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadTransferArticulationMapping && showTransferArticulationMappingUpload">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'transferArticulationMappingList' }" :aria-label="$t('transferArticulation')">
                          {{ $t('transferArticulation') }}
                        </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canViewUploadHistory">
                        <b-dropdown-item :disabled="isSandboxUser || permission.systemPermission.readOnly" :to="{ name: 'uploadHistory' }" :aria-label="$t('backgroundTaskHistory')">
                          {{ $t('backgroundTaskHistory') }}
                        </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canAssignCoach">
                        <b-dropdown-item :disabled="isSandboxUser || permission.systemPermission.readOnly" :to="{ name: 'coacheeAssignment' }" :aria-label="$t('coachAssignment')">
                          {{ $t('coachAssignment') }}
                        </b-dropdown-item>
                      </template>

                      <!-- TODO: Remove this link after creating 'Employer Admin' user -->
                      <template v-if="permission.menuItemPermission.canAdministerEmployer">
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'employerAdmin' }" :aria-label="$t('employerJobCenterAria')">
                          {{ $t('employerJobCenter') }}
                        </b-dropdown-item>
                      </template>
                    </div>
                  </div>

                  <div class="links_block" v-if="permission.menuItemPermission && isInstructorLogin">
                    <div class="header">
                      {{ $t('hdManage') }}
                    </div>
                    <div class="links">
                      <template>
                        <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'myCourseSections' }" :aria-label="$t('myCourses')">
                          {{ $t('myCourses') }}
                        </b-dropdown-item>
                      </template>
                      <div class="menu_sub_hd" v-if="institutions.length>1">
                      {{ $t('myInstitutions') }}
                      </div>
                      <template v-if="institutions.length>1" v-for="ins in institutions" >
                        <b-dropdown-item :disabled="isSandboxUser" @click="changeInstitution(ins)" :aria-label="ins.title">
                          {{ ins.title }}
                        </b-dropdown-item>
                      </template>
                    </div>
                  </div>

                  <div class="links_block" v-if="permission.menuItemPermission && permission.menuItemPermission.canCreate">
                    <div class="header">
                      {{ $t('create') }}
                    </div>
                    <div class="links">
                      <template v-if="permission.menuItemPermission.canCreateAsset">
                          <b-dropdown-item :disabled="isSandboxUser || permission.systemPermission.readOnly" :to="{ name: 'assetCreate' }" :aria-label="$t('asset')">
                            {{ $t('asset') }}
                          </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canCreateQuestion">
                          <b-dropdown-item :disabled="isSandboxUser || permission.systemPermission.readOnly" :to="{ name: 'createItem' }" :aria-label="$t('ques')">
                            {{ $t('ques') }}
                          </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canCreateAssessment">
                          <b-dropdown-item :disabled="isSandboxUser || permission.systemPermission.readOnly" :to="{ name: 'createAssessment' }" :aria-label="$t('createAssessmentAria')">
                            {{ $t('assessment') }}
                          </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canCreateMasterCourse">
                          <b-dropdown-item v-if="isAdminLogin" :disabled="isSandboxUser || permission.systemPermission.readOnly" :to="{ name: 'courseCreate' }" :aria-label="$t('masterCourseAria')">
                            {{ $t('masterCourse') }}
                          </b-dropdown-item>
                      </template>
                      <template v-if="permission.menuItemPermission.canCreateMasterCourse">
                          <b-dropdown-item v-if="isAdminLogin"  :to="{ name: 'microCompetencyCreate' , params: {opstate:2}}" :aria-label="$t('microCompetencyAria')">
                            {{ $t('microCompetency') }}
                          </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canCreateRichHtmlAsset">
                          <b-dropdown-item :disabled="isSandboxUser || permission.systemPermission.readOnly" :to="{ name: 'htmlAssetCreate' }" aria-label="create html rich asset">
                            {{ $t('htmlRichAsset') }}
                          </b-dropdown-item>
                      </template>

                    </div>
                  </div>

                  <div class="links_block" v-if="permission.menuItemPermission && permission.menuItemPermission.canUpload">
                    <div class="header">Upload</div>
                    <div class="links">
                      <template v-if="permission.menuItemPermission.canUploadJob">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'jobUpload' }" aria-label="upload jobs">
                            {{ $t('job') }}
                          </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadClub">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'clubUpload' }" aria-label="upload club">
                            {{ $t('club') }}
                          </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadEvent">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'eventUpload' }" aria-label="upload event">
                            {{ $t('event') }}
                          </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadAsset">
                          <b-dropdown-item :disabled="isSandboxUser || permission.systemPermission.readOnly" :to="{ name: 'assetUpload' }" aria-label="upload assets">
                            {{ $t('asset') }}
                          </b-dropdown-item>
                      </template>
                      <template v-if="permission.menuItemPermission.canUploadAsset">
                          <b-dropdown-item :disabled="isSandboxUser || permission.systemPermission.readOnly" :to="{ name: 'scormUpload' }" aria-label="upload scorm">
                            {{ $t('scorm') }}
                          </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadAsset">
                          <b-dropdown-item :disabled="isSandboxUser || permission.systemPermission.readOnly" :to="{ name: 'diagnosticLogicMappingUpload' }" aria-label="upload diagnostic logic mapping">
                            {{ $t('diagnosticLogicMapping') }}
                          </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadPerson">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'personUpload' }" aria-label="upload person">
                            {{ $t('person') }}
                          </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadMajorMinor">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'majorMinorUpload' }" aria-label="upload major minor">
                            {{ $t('majorMinor') }}
                          </b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadMajorMinor">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'institutionCareerUpload' }" aria-label="upload institution careers">Institution Careers</b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadCourseOption">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'courseOptionsUpload' }" aria-label="upload course options">Course Option</b-dropdown-item>
                      </template>

                      <!--
                      <template v-if="permission.menuItemPermission.canUploadProgramGuide">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'programGuideUpload' }" aria-label="upload program guide">Program Guide</b-dropdown-item>
                      </template>
                      -->

                      <template v-if="permission.menuItemPermission.canUploadAlumniAutoStream">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'alumniStreamUpload' }" aria-label="upload alumni stream" >Alumni Stream</b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadAdvisorStream">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'advisorStreamUpload' }" aria-label="upload advisor stream" >Advisor Stream</b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadStudentAutoStream">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'studentStreamUpload' }" aria-label="upload student stream">Student Stream</b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadAdvisorAdvisee">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'adviseeAdvisorUpload' }" aria-label="upload adviser advisee">Advisor Advisee</b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadCatalog">
                          <!--
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'catalogUpload' }" aria-label="upload catalog">Catalog</b-dropdown-item>
                          -->
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'catalogSkillTagUpload' }" aria-label="upload catalog skill tag">Catalog Skill Tag</b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadCourseOption">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'aarRequirementsUpload' }" aria-label="upload aar requirements">AAR Requirements</b-dropdown-item>
                      </template>

                      <template v-if="permission.menuItemPermission.canUploadMajorMinor">
                          <b-dropdown-item :disabled="isSandboxUser" :to="{ name: 'alumniInsightBulkUpload' }" aria-label="upload major minor">Bulk Alumni Insight</b-dropdown-item>
                      </template>
                    </div>
                  </div>

                  <div class="links">
                      <b-dropdown-item :to="{ name: dashboardName }" class="lnk_menu lnk_menu_footer" aria-label="dashboard">
                        <span class="ic icon-home"></span>
                        <span class="lnk_txt">
                          {{ $t('dashboard') }}
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item v-if="isExplorePackageEnabled" :to="{ name: 'exploreIntro', params: { reload: true} }" class="lnk_menu lnk_menu_footer" aria-label="explore">
                        <span class="ic icon-explore"></span>
                        <span class="lnk_txt">
                          {{ $t('hdExplore') }}
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item v-if="isJobBoardEnabled" :to="{ name: 'jobBoard', params: { reload: true} }" class="lnk_menu lnk_menu_footer" :aria-label="getJobBoardLabel">
                        <span class="ic ic2_job-briefcase"></span>
                        <span class="lnk_txt">
                          {{ getJobBoardLabel }}
                        </span>
                      </b-dropdown-item>
                  </div>

                </div>
              </b-dropdown>

            </template>


            <template v-if="isNotCusomAdmin">
              <div class="discover_section" v-show="!isSandboxUser && permission.institutionPermission.canDiscover">

                  <button v-if="!isSearchBarEnabled" class="btn search_global" @click="showSearchBar">
                    <span class="ic ic9-searchGlobal">
                      <span class="visibility_hide">search</span>
                    </span>
                  </button>

                  <template v-if="isSearchBarEnabled">
                    <div class="course_search_dropdown">
                      <course-search-drop-down ref="courseSearch"
                        v-on:search-button-clicked="updateSearchTerm"
                        v-on:course-search-selected="isShowFolderSettingPopup = false">
                      </course-search-drop-down>
                    </div>

                    <div class="header_search_container">
                      <input
                        type="text"
                        ref="searchBox"
                        class="input-search"
                        @click="checkForAdvancedSearch"
                        :placeholder="$t('typeInSearchTermAndOrClickSearchPH')"
                        v-on:keyup.enter="navigateToSearchResults"
                        v-on:keydown="keydownEvent"
                        aria-label="type in search term and/or click search"
                        v-model.trim="searchTerm">
                      <button id="folderSetting" class="fa fa-cog" aria-label="folder setting" @click="toggleFolderSettingPopup"></button>
                      <button class="btn search-button-container" @click="navigateToSearchResults" aria-label="search button">
                        <!--
                        <span class="ic_srh icon-search"></span>
                        <span class="txt_srh">search</span>
                        -->
                        <span class="ic ic9-searchGlobal"></span>
                      </button>
                      <button
                        class="btn arr_lft"
                        @click="hideSearchBar"
                        :title="hideSearchBarTitle"
                        v-b-tooltip.hover>
                          <span class="ic ic9-arr_pre"></span>
                      </button>
                      <template v-if="isShowFolderSettingPopup">
                        <folder-setting
                          v-bind:selectedFolders.sync="selectedFolders"
                          @after-shown="afterFolderSettingPopupShown"
                          :show-setting-popup="isShowFolderSettingPopup"
                          :do-not-open-folder-setting-automatically="doNotOpenFolderSettingAutomatically">
                        </folder-setting>
                      </template>
                    </div>
                  </template>

                </div>
            </template>
            <!--
            <div class="navigation-right-section">
            <a href="#/careerIdea" class="btn btn-primary" target="_self" v-if="isStudentLogin && enableCareerIdea" >Career Ideas</a>
            </div>
            -->
          </div>
        </div>
      </div>

    </div>
    <!-- .logo_container -->

    <div class="col-4 inst_logo_container">
      <img class="logo ace_sec" :src="logoUrl" alt="institution logo">
    </div>

    <div class="col-4 user-menu" :class="!isTempUser ? '' : 'temp_user'">

      <b-navbar toggleable="md" type="light">
          <b-collapse is-nav id="nav_collapse">
              <b-navbar-nav class="ml-auto">

                <!-- Advisor Button Group -->
                <template v-if="!isShowingTermAndCondition">
                  <template v-if="showSecondaryNavBar">

                    <template v-if="isProspectiveStudentLogin && isAskAdvisorEnabled">
                      <li class="nav-item platform-advisor-nav-item">
                        <button type="button" class="btn btn_advisor ace_sec" @click="showAskAdvisorModal">{{askAdvisorLabel}}</button>
                      </li>
                    </template>
                    <template v-if="isStudentLogin && isChannelEnabled && isChannelAvailable && isChannelReady && isAskAdvisorEnabled">
                      <li class="nav-item platform-advisor-nav-item">
                        <button type="button" class="btn btn_advisor ace_sec" @click="navigateToChannel">{{askAdvisorLabel}}</button>
                      </li>
                    </template>
                    <!-- profile Modal Component -->
                    <b-modal ref="loadingAskAdvisorModal" centered hide-footer class="profile-new-popup ask_advisor" no-close-on-backdrop>

                      <template slot="modal-header">
                        <div class="head_txt col-12">{{askAdvisorLabel}}</div>
                          <b-btn
                              size="sm"
                              class="btn_close"
                              variant="primary"
                              @click="hideAskAdvisorPopup"
                              aria-lable="close profile popup">
                                <span class="ic-close">
                                  <span class="visibility_hide">close</span>
                                </span>
                          </b-btn>
                      </template>

                      <div class="content-section">
                          <div class="right-col">

                            <div class="field-section">
                                  <div class="field-row">
                                      <p>Please fill out this form and someone from the institution will get in touch with you soon!</p>
                                  </div>
                              </div>

                              <div class="field-section">
                                  <div class="field-row">
                                      <div class="field-title" id="majorValue">First Name</div>
                                      <div class="field-form">
                                          <input type="text" class="input-search" aria-labelledby="majorValue" v-model="prospectiveStudentProfile.firstName">
                                      </div>
                                  </div>
                              </div>

                              <div class="field-section">
                                  <div class="field-row">
                                      <div class="field-title" id="minorValue">Last Name</div>
                                      <div class="field-form">
                                          <input type="text" class="input-search" aria-labelledby="minorValue" v-model="prospectiveStudentProfile.lastName">
                                      </div>
                                  </div>
                              </div>

                              <div class="field-section">
                                  <div class="field-row">
                                      <div class="field-title" id="concentrationValue">Phone</div>
                                      <div class="field-form">
                                          <input type="text" class="input-search" aria-labelledby="concentrationValue" v-model="prospectiveStudentProfile.primaryPhoneNumber">
                                      </div>
                                  </div>
                              </div>

                              <div class="field-section">
                                  <div class="field-row">
                                      <div class="field-title"></div>
                                      <div class="field-form btn_container" style="text-align: right;">
                                        <VueLoadingButton
                                          aria-label="Post message"
                                          class="btn btn-secondary btn-lg"
                                          @click.native="submitAskAdvisor()"
                                          :loading="showSubmitAskAdvisorLoader"
                                        >Submit</VueLoadingButton>
                                      </div>
                                  </div>
                              </div>

                          </div>

                      </div>

                    </b-modal>

                  </template>
                </template>
                <!-- Advisor Button Group -->

                <button id="bookmarkTour" class="btn_bookmark ace_sec" tabindex="0" v-if="!isShowingTermAndCondition && isExplorePackageEnabled && isBookmarkEnabled" aria-label="Bookmarks" title="Bookmarks" @click="viewBookmarks">
                  <span class="icon-bookmark"></span>
                </button>

                <!-- Legend is enabled -->
                <template v-if="!isShowingTermAndCondition && !disableLegend">

                  <!-- showDashboardLegend is enabled -->
                  <template v-if="showDashboardLegend" tabindex="0">
                    <b-nav-item class="legend-popup legends_sec" aria-label="page legend">
                      <div id="legendPopup1" class="legends-popover"></div>
                      <div class="btn_legends" aria-label="progress legend">
                          <div class="legends_container">
                            <b-button
                              class="btn_legends"
                              id="progressLegends1"
                              :title="$t('legend')">
                                <span class="sq_1 yellow"></span>
                                <span class="sq_2 red"></span>
                                <span class="sq_3 green"></span>
                                <span class="sq_4 orange"></span>
                            </b-button>

                            <b-popover
                              ref="legendModal1"
                              target="progressLegends1"
                              triggers="hover focus"
                              container="legendPopup1"
                              placement="left"
                              :offset="60">

                              <template slot="title">
                                <div class="row">
																	<div class="col-10 header-title">
                                    {{ $t('legend') }}
                                  </div>
																	<div class="col-2">
																		<b-btn
                                      class="btn_close"
                                      @click="closeLegendPopup"
                                      :aria-label="$t('closeAria')"
                                      :title="$t('closeTitle')"
                                      v-b-tooltip.hover>
                                        <span class="ic-close"></span>
																		</b-btn>
																	</div>
																</div>
                              </template>
                              <div class="row">
                                <div class="col-12 performance-section">
                                  <div class="status_row ace_sec_txt" aria-label="Transferred"><span class="lg_blc transferred"></span> Transferred </div>
                                  <div class="status_row ace_sec_txt" aria-label="Completed"><span class="lg_blc completed"></span> Completed </div>
                                  <div class="status_row ace_sec_txt" aria-label="In Progress"><span class="lg_blc in_progress"></span> In Progress </div>
                                  <div class="status_row ace_sec_txt" aria-label="Scheduled"><span class="lg_blc scheduled"></span> Scheduled </div>
                                  <div class="status_row ace_sec_txt" aria-label="Credits/Courses Needed"><span class="lg_blc credits_needed"></span>  Credits/Courses Needed </div>
                                  <!--<div class="status_row"><span class="lg_blc not_in_plan"></span>  Course not in Program </div>-->
                                </div>
                              </div>
                            </b-popover>
                          </div>
                      </div>
                    </b-nav-item>
                  </template>

                  <!-- showProgressLegend -->
                  <template v-if="showProgressLegend && !showCombinedLegend">
                    <b-nav-item class="legend-popup legends_sec">
                      <div id="legendPopup2"></div>
                      <div class="btn_legends" aria-label="progress legend">
                        <div class="legends_container">
                          <b-button
                            class="btn_legends"
                            id="progressLegends2"
                            aria-label="legends popup, press enter key for legends details"
                            :title="$t('legend')"
                            v-b-tooltip.hover>
                              <span class="sq_1 yellow"></span>
                              <span class="sq_2 red"></span>
                              <span class="sq_3 green"></span>
                              <span class="sq_4 orange"></span>
                          </b-button>

                          <b-popover ref="legendModal1" target="progressLegends2" triggers="click focus" container="legendPopup2" placement="left" :offset="60">
                            <template slot="title">
                              <div class="row">
																<div class="col-10 header-title">
                                  {{ $t('legend') }}
                                </div>
																<div class="col-2">
																	<b-btn
                                    class="btn_close"
                                    @click="closeLegendPopup"
                                    :aria-label="$t('closeAria')"
                                    :title="$t('closeTitle')"
                                    v-b-tooltip.hover>
                                      <span class="ic-close"></span>
																	</b-btn>
																</div>
															</div>
                            </template>
                            <div class="row" v-if="!isSupervisor">
                              <div class="col-6 progress-section mt-2">
                                <div class="legend-title ace_sec"
                                  aria-label="legends for progress">
                                    {{ $t('progress') }}
                                </div>
                                <div class="status_row ace_sec">
                                  <span class="completed icon-progress"></span>
                                  {{ $t('completed') }}
                                </div>
                                <div class="status_row ace_sec">
                                  <span class="in_progress icon-progress"></span>
                                  {{ $t('inProgress') }}
                                </div>
                                <div class="status_row ace_sec">
                                  <span class="failed icon-progress"></span>
                                  {{ $t('needsImprovement') }}
                                </div>
                                <div class="status_row ace_sec">
                                  <span class="not_started icon-progress"></span>
                                  {{ $t('notStarted') }}
                                </div>
                              </div>
                              <div class="col-6 performance-section mt-2">
                                <div class="legend-title">
                                  {{ $t('performance') }}
                                </div>
                                <div class="status_row ace_sec" aria-label="grade A - 90% to 100%">
                                  <span class="lg_blc gradeA"></span>
                                  90% - 100%
                                </div>
                                <div class="status_row ace_sec" aria-label="grade B - 80% to 89%">
                                  <span class="lg_blc gradeB"></span>
                                  80% - 89%
                                </div>
                                <div class="status_row ace_sec" aria-label="grade C - 65% to 79%">
                                  <span class="lg_blc gradeC"></span>
                                  65% - 79%
                                </div>
                                <div class="status_row ace_sec" aria-label="grade D - 40% to 64%">
                                  <span class="lg_blc gradeD"></span>
                                  40% - 64%
                                </div>
                                <div class="status_row ace_sec" aria-label="grade E - 0% to 39%">
                                  <span class="lg_blc gradeE"></span>
                                  0% - 39%
                                </div>
                                <div class="status_row ace_sec" aria-label="no grade">
                                  <span class="lg_blc noGrade"></span>
                                  N/A
                                </div>
                              </div>
                            </div>
                            <div class="row" v-if="isSupervisor">
                              <div class="col-12 performance-section mt-2">
                                <div class="legend-title">Deadline</div>
                                <div class="status_row">
                                  <span class="lg_blc deadline_completed"></span>
                                  {{ $t('completed') }}
                                </div>
                                <div class="status_row">
                                  <span class="lg_blc deadline_4weekplus"></span>
                                  not started
                                </div>
                                <div class="status_row">
                                  <span class="lg_blc deadline_4week"></span>
                                  4 weeks to deadline
                                </div>
                                <div class="status_row">
                                  <span class="lg_blc deadline_2week"></span>
                                  2 weeks to deadline
                                </div>
                                <div class="status_row">
                                  <span class="lg_blc deadline_missed"></span>
                                  deadline missed
                                </div>
                              </div>
                            </div>

                          </b-popover>
                        </div>
                      </div>
                    </b-nav-item>
                  </template>

                  <!-- showDashboardLegend & showProgressLegend both -->
                  <template v-if="showProgressLegend && showCombinedLegend">
                    <b-nav-item class="legend-popup legends_sec">
                          <div id="legendPopup3" class="legends-popover"></div>
                          <div class="btn_legends" aria-label="progress legend">
                              <div class="legends_container">
                                <b-button class="btn_legends" id="progressLegends3" title="Legend">
                                  <span class="blue"></span>
                                  <span class="red"></span>
                                  <span class="green"></span>
                                  <span class="yellow"></span>
                                </b-button>

                                <b-popover target="progressLegends3" triggers="hover focus" container="legendPopup3" placement="left" :offset="60">
                                      <template slot="title"> <div class="header-title ace_sec" aria-label="Legend">Legend</div> </template>
                                      <div class="row">
                                          <div class="col-4 performance-section mt-2">
                                              <div class="legend-title ace_sec" aria-label="legends for degree progress">Degree Progress</div>
                                              <div class="status_row ace_sec" aria-label="Transferred"><span class="lg_blc transferred"></span> Transferred </div>
                                              <div class="status_row ace_sec" aria-label="Completed">
                                                <span class="lg_blc completed"></span>
                                                {{ $t('completed') }}
                                              </div>
                                              <div class="status_row ace_sec" aria-label="In Progress"><span class="lg_blc in_progress"></span> In Progress </div>
                                              <div class="status_row ace_sec" aria-label="Scheduled"><span class="lg_blc scheduled"></span> Scheduled </div>
                                              <div class="status_row ace_sec" aria-label="Credits Needed"><span class="lg_blc credits_needed"></span>  Credits Needed </div>
                                              <div class="status_row ace_sec" :aria-label="'Course not in ' + exploreProgramsLabel"><span class="lg_blc not_in_plan"></span>  Course not in {{exploreProgramsLabel}} </div>
                                          </div>
                                          <div class="col-4 performance-section mt-2">
                                              <div class="legend-title ace_sec" aria-label="legends for performance">Performance</div>
                                              <div class="status_row ace_sec" aria-label="grade A - 90% to 100%"><span class="lg_blc gradeA"></span> 90% - 100% </div>
                                              <div class="status_row ace_sec" aria-label="grade A - 80% to 89%"><span class="lg_blc gradeB"></span> 80% - 89% </div>
                                              <div class="status_row ace_sec" aria-label="gradeA - 65% to 79%"><span class="lg_blc gradeC"></span> 65% - 79% </div>
                                              <div class="status_row ace_sec" aria-label="gradeA - 40% to 64%"><span class="lg_blc gradeD"></span> 40% - 64% </div>
                                              <div class="status_row ace_sec" aria-label="grade E - 0% to 39%"><span class="lg_blc gradeE"></span>  0% - 39% </div>
                                              <div class="status_row ace_sec" aria-label="no grade"><span class="lg_blc noGrade"></span>  N/A </div>
                                          </div>
                                          <div class="col-4 progress-section mt-2 course_progress">
                                              <div
                                                class="legend-title ace_sec"
                                                aria-label="legends for Course Progress">
                                                Course Progress
                                              </div>
                                              <div
                                                class="status_row ace_sec"
                                                aria-label="legend for completed">
                                                  <span class="completed icon-progress"></span>
                                                  {{ $t('completed') }}
                                              </div>
                                              <div class="status_row ace_sec" aria-label="legend for in progress"><span class="in_progress icon-progress"></span> in progress</div>
                                              <div class="status_row ace_sec" aria-label="legend for failed"><span class="failed icon-progress"></span> needs improvement</div>
                                              <div class="status_row ace_sec" aria-label="legend for not started"><span class="not_started icon-progress"></span> not started</div>
                                          </div>
                                      </div>
                                </b-popover>
                              </div>
                          </div>
                      </b-nav-item>
                  </template>

                </template>

                  <!--<div class="fas fa-comment-alt"><span class="circle"></span></div>-->

                  <template v-if="!isShowingTermAndCondition && isNotCusomAdmin && isChannelEnabled">
                    <div class="channel-place" v-if="isChannelAvailable && isChannelReady && !isClearlyNextPackageEnabled">
                      <button
                        type="button"
                        class="channel-btn ace_sec"
                        @click="navigateToChannel"
                        :aria-label="channelLabel + ' you have ' + unreadCountState + ' new message'"
                        :title="channelLabel"
                        v-b-tooltip.hover>
                          <span class="icon-channel">
                            <span class="visibility_hide">C</span>
                          </span>
                          <span v-if="unreadCountState > 0" class="notification-count">{{ unreadCountState }}</span>
                      </button>
                    </div>
                  </template>

                  <li
                    v-if="usePragyaHelp && userObj && userObj.uuid && !isShowingTermAndCondition"
                    class="nav-item platform-help-nav-item"
                  >
                    <platform-help-panel
                      :institution="institution"
                      :user-role="userRole"
                      :user-id="userObj.uuid"
                    />
                  </li>

                  <!--
                  <span class="navigation-bar-help" v-if="isStudentLogin">
                      <a href="https://pragya2.s3-us-west-2.amazonaws.com/5ac44200e4b07c89dbe2df8c-NuNavStudentTutorial.pdf" target="_blank">
                        <span class="icon-help"></span>
                      </a>
                  </span>
                  -->
                  <b-dropdown
                    right
                    v-if="!isTempUser"
                    :class="['user_menu_dropdown', { 'user_menu_dropdown--pragya-help': usePragyaHelp }]"
                    aria-label="User Menu"
                    id="userNavMenu"
                  >
                      <!-- Using button-content slot -->
                      <template slot="button-content" id="profileTour">
                        <span id="tooltip" class="username" :aria-label="username + ' profile'" v-b-tooltip.hover :title="username" v-html="username.charAt(0).toUpperCase()"></span>
                      </template>

                      <template v-if="isClearlyNextPackageEnabled">
                        <template v-if="!isShowingTermAndCondition">
                          <b-dropdown-item :to="{ name: 'userSettings', params: { uuid: userUuid }}" aria-label="user profile settings">
                            {{ $t('settings') }}
                          </b-dropdown-item>
                          <template v-if="showAccountSubscription">
                            <b-dropdown-item :to="{ name: 'clearlyNextStudentSubscription', params: { uuid: userUuid }}" aria-label="user account">
                              {{ $t('account') }}
                            </b-dropdown-item>
                          </template>
                        </template>
                      </template>
                      <template v-else>
                        <template v-if="!isShowingTermAndCondition && !isCapsico">
                          <template v-if="permission.userPermission.studentHomeView && isLearnerDashboardEnabled">
                            <b-dropdown-item tabindex="0" @click="completeYourProfileClicked" aria-lable="Profile">
                              {{ $t('myProfile') }}
                            </b-dropdown-item>
                          </template>
                          <template v-else>
                            <b-dropdown-item tabindex="0" :to="{ name: 'userProfile', params: { dashboardName: dashboardName }}" :disabled="!showProfilePopup">
                              {{ $t('myProfile') }}
                            </b-dropdown-item>
                          </template>
                          <!--<b-dropdown-item :to="{ name: 'userTour', params: { dashboardName: dashboardName }}" :disabled="!isTourEnabled">Show tour</b-dropdown-item>-->
                          <b-dropdown-item tabindex="0" @click="updateForceTourElements" :disabled="!isTourEnabled">
                            {{ $t('showTour') }}
                          </b-dropdown-item>
                          <b-dropdown-item v-if="isWalletEnabled" tabindex="0" :to="{ name: 'wallet'}" aria-label="my wallet">
                            {{ $t('myWallet') }}
                          </b-dropdown-item>

                          <b-dropdown-item tabindex="0" :to="{ name: 'privacyPolicy'}" aria-label="privacy policy">
                            {{ $t('privacy') }}
                          </b-dropdown-item>
                          <b-dropdown-item tabindex="0" :to="{ name: 'dataPrivacy'}" aria-label="data privacy policy" v-if="isXprizeDataOptOutEnabled">{{getDataOptOutLabel}}</b-dropdown-item>
                          <b-dropdown-item tabindex="0" :to="{ name: 'userSettings', params: { uuid: userUuid }}" aria-label="user profile settings">
                            {{ $t('settings') }}
                          </b-dropdown-item>
                          <span class="menu_sub_hd">
                            {{ $t('hdThemes') }}
                          </span>
                          <b-dropdown-item class="theme_lnk_default" tabindex="0" @click="disableAdaComplianceCss" aria-label="default theme">
                            {{ $t('themeDefault') }}
                          </b-dropdown-item>
                          <b-dropdown-item class="theme_lnk_ada"tabindex="0" @click="enableAdaComplianceCss" aria-label=" a d a theme">
                            {{ $t('themeADA') }}
                          </b-dropdown-item>
                          <span class="menu_sub_hd">
                            {{ $t('changeLanguage') }}
                          </span>
                          <b-dropdown-item
                            class=""
                            :class="{ lang_selected: $i18n.locale === 'en' }"
                            tabindex="0"
                            @click="changeLanguage('en')"
                            aria-label="default locale : English">
                              English
                          </b-dropdown-item>
                          <b-dropdown-item
                            class=""
                            :class="{ lang_selected: $i18n.locale === 'es' }"
                            tabindex="0"
                            @click="changeLanguage('es')"
                            aria-label="locale : Español">
                              Español
                          </b-dropdown-item>
                        </template>
                      </template>
                      <span class="lnk_sep"></span>
                      <b-dropdown-item :to="{ name: 'userLogout', params: {isShowingTermAndCondition: isShowingTermAndCondition}}" class="last_child" aria-label="logout">
                        {{ $t('logout') }}
                      </b-dropdown-item>
                  </b-dropdown>

              </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>

    <template v-if="isChannelAvailable && isUserAuthenticatedOnFirebase">
        <channel :externalId="currentChannel" :channelData="currentChannelInformation"></channel>
    </template>

    <div v-if="!isShowingTermAndCondition">
      <div class="form_modal_popup">
        <b-modal class="h-100 d-inline-block" id="no-program-modal-popup" ref="noEnrolledProgramModal" size="lg" :header-bg-variant="'light'" hide-footer no-close-on-backdrop no-close-on-esc>
          <div slot="modal-header" class="header-section w-100">
            <div class="popup_head_txt float-left">
              <span>You are not enrolled in a learning {{exploreProgramsLabel}}</span>
            </div>
            <div class="float-right">
              <button class="btn_close" aria-label="close" @click="cancelNoEnrolledProgramModal">
                <span class="ic-close"></span>
              </button>
            </div>
          </div>
          <div class="modal_content">
            <div class="row mb-4 mt-4">
              <div class="col-1"></div>
              <div class="col-11">
                <div class="row">
                  <div class="col-12 mb-4">
                    <div v-if="showCourseMessage">
                      <span>This page will show the Courses for the learning {{exploreProgramsLabel}} you have enrolled in.  You will be able to  view {{exploreProgramsLabel}} requirements and track your progress through the {{exploreProgramsLabel}} (if supported by your institution) </span>
                    </div>
                    <div v-else>
                      <span>This page will show the {{exploreProgramsLabel}} you have enrolled in. </span>
                    </div>
                  </div>
                  <!--
                  <div class="col-12 mb-4">
                    <div class="float-left" style="width: 70%;">
                      <autocomplete
                        ref="programInterestAutocomplete"
                        :source="interestedPrograms"
                        :placeholder="programInterestPlaceholder"
                        input-class="form-control"
                        :results-display="programInterestFormattedDisplay"
                        @selected="afterProgramInterestSelected">
                      </autocomplete>
                    </div>
                    <div class="float-left" style="margin-left: -15px;">
                      <b-button @click="navigateToSelectedProgramInterest" style="height: 40px;">go</b-button>
                    </div>
                  </div>
                  -->
                  <div class="col-12 mb-4">
                    <span>Check out some of the highlighted {{exploreProgramsLabelPlural}} on your <a href="javascript://" @click="homePageClicked">Home page</a>. You can also <a href="javascript://" @click="exploreProgramsClicked"> explore all available {{exploreProgramsLabelPlural}}</a> and enroll in the {{exploreProgramsLabel}} of your choice.</span>
                  </div>
                  <!--
                  <div class="col-12 mb-4">
                    <span>You could also help us help you by <a href="javascript://" style="color: #157099;" @click="completeYourProfileClicked">completing your profile.</a></span>
                  </div>
                  -->
                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </div>

  </div>
</template>

<script>
import vuex from '../../vuex'
import Channel from '../../channel/components/Channel'
import CourseSearchDropDown from '../../search/components/CourseSearchDropDown'
import { mapActions, mapState } from 'vuex'
import { auth, db } from '../../../firebase'
import FolderSetting from '../../search/components/FolderSetting'
import '../../../assets/module/css/common/legendsPopover.min.css'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import VueLoadingButton from 'vue-loading-button'
import Autocomplete from 'vuejs-auto-complete'
import FontPicker from 'font-picker-vue'
import _ from 'lodash'
import PlatformHelpPanel from './PlatformHelpPanel.vue'
import { USE_PRAGYA_HELP } from '../../../config/pragyaHelp.js'

export default {
  name: 'navigation',
  components: {
    Channel,
    'font-picker': FontPicker,
    FolderSetting,
    CourseSearchDropDown,
    VueLoadingButton,
    Autocomplete,
    PlatformHelpPanel,
  },
  data: () => {
    return {
      user: vuex.user,
      tempUsername: vuex.user.state.userFullName,
      tempUserRole: vuex.user.state.userRole,
      tempUserObj: vuex.user.state.userObj,
      dashboard: vuex.dashboard,
      channel: vuex.channel,
      searchTerm: '',
      isDiscoverEnabled: true,
      isUserAuthenticatedOnFirebase: false,
      isChannelDataLoaded : false,
      enableChannelEmails: ['inst1@nu.com', 'admin@nu.com', 'mstuart2@nu.edu', 'gwilt@nu.edu', 'hmakhluf@nu.edu', 'wramos@nu.edu', 'robert.birdsell@natuniv.edu', 'david.sandles@natuniv.edu'],
      sandboxUsers: ['demoinstructor2@nu.com', 'i1@csu.edu', 'i2@csu.edu', 'i1@vc.edu', 'i2@vc.edu', 'randolph.ward@teachforamerica.org', 'cassandra.zimmer@teachforamerica.org', 'caitlin.ormsby@teachforamerica.org', 'bkransberger@nu.edu', 'i1@lsc.edu', 'i1@pima.edu', 'trinaldi@nu.edu', 'jzavala@nu.edu'],
      isShowFolderSettingPopup: false,
      selectedFolders: [],
      doNotOpenFolderSettingAutomatically: false,
      superAdminPermissionName: 'SUPERADMIN_PERMISSION',
      isNuNavLogin: (window.location.host.indexOf('nunav') !== -1 || window.location.host.indexOf('competencyedu') !== -1 || window.location.host.indexOf('wsp') !== -1),
      prospectiveStudentProfile: {
        firstName: '',
        lastName: '',
        eMail: '',
        primaryPhoneNumber: ''
      },
      showSubmitAskAdvisorLoader: false,
      isSearchBarEnabled: false,
      pageToRedirect: '',
      showCourseMessage : false,
      interestedPrograms: [],
      selectedProgramInterest: {},
      learnerEnrollmentData: [],
      institutionCount:1,
      apiKey: 'AIzaSyAa3D-xZhJGxFRI2cxDX6iInTwA4hKy3pc',
      institutionTheme: {},
      userTransactions: [],
      myProgramsMenu: false,
      showLinkSize:2,
      institutions: []
    }
  },
  directives: {
    'click-outside': {
      bind(el, binding) {
        el.__clickOutsideHandler__ = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            if (typeof binding.value === 'function') {
              binding.value(event);
            }
          }
        };
        document.body.addEventListener('click', el.__clickOutsideHandler__);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.__clickOutsideHandler__);
        delete el.__clickOutsideHandler__;
      },
    },
  },
  created () {
/* This is called later in mounted. multiple call performance issue
    if (!this.isShowingTermAndCondition) {
      this.populateNamedQueries()
    }
*/
    this.loadPermission().then(res => {
      this.loadInstitutionDetail().then(institution => {
        let institutionId = institution.uuid || this.institutionUuid
        this.loadInstitutionPackage({uuid: institutionId, isAggregated: false}).then(res => {
          if (this.isZendeskEnabled) {
            // this.loadAuthenticateWebWidget()
          }
/* This is called later in mounted. multiple call performance issue
          this.loadChannelSetup()
*/
          this.loadSelfRegistrationConfiguration(institutionId).then(configuration => {
            this.institutionTheme = configuration
            let root = document.documentElement;
            root.style.setProperty("--InstFontFamily", this.institutionTheme.fontFamily); // Font Family
            root.style.setProperty("--TU__BaseTxtClr", this.institutionTheme.backgroundColor); // Other Text Color
            root.style.setProperty("--TU__BtnClrPri", this.institutionTheme.primaryColor); // Button Color
            root.style.setProperty("--TU__BtnTxtClrPri", this.institutionTheme.secondaryColor); // Button Text Color
            root.style.setProperty("--TU__BtnHoverClrPri", this.institutionTheme.buttonHoverColor); //Button Hover Color
            root.style.setProperty("--TU__BtnTxtHoverClrPri", this.institutionTheme.secondaryColor); // Button Text Color
            root.style.setProperty("--TU__BtnClrSec", this.institutionTheme.primaryColor); // Button Color
            root.style.setProperty("--TU__BtnHoverClrSec", this.institutionTheme.buttonHoverColor);  //Button Hover Color
            root.style.setProperty("--TU__LnkClrPri", this.institutionTheme.linkColor); // Link Color
            root.style.setProperty("--TU__LnkHoverClrPri", this.institutionTheme.linkHoverColor); // Link Hover Color
            root.style.setProperty("--TU__LnkClrSec", this.institutionTheme.backgroundColor); // Other Text Color
            root.style.setProperty("--TU__LnkHoverClrSec", this.institutionTheme.backgroundColor); // Other Text Color
          })
          // this.applyInstituteTheme(institution.title)
          this.populateDashboardState()
          // this.populateInterestedPrograms()
        })
      })
    })
  },
  async mounted () {
    if (!this.isShowingTermAndCondition) {
      await this.applyUserRoleClass()
      await this.loadUserInfo()
      this.prospectiveStudentProfile.firstName = this.userObj.firstName
      this.prospectiveStudentProfile.lastName = this.userObj.lastName
      this.prospectiveStudentProfile.primaryPhoneNumber = this.userObj.primaryPhoneNumber
      this.populateDashboardState()
      this.loadQuickLinks()
    }
    this.$root.$on('loadChannelAndZendesk', () => {
      this.populateNamedQueries()
      if (this.shouldLoadZendesk) {
        this.loadAuthenticateWebWidget()
      }
      this.loadChannelSetup()
    })
    this.$root.$on('reloadLearnerDashboard', () => {
      this.populateDashboardState()
    })
    this.setADASetting()
    this.userTransactions = await this.loadUserTransactions()
    $('#userNavMenu .dropdown-menu').attr("aria-labelledby", "userNavMenu__BV_toggle_");
    this.loadAllUserInstitution(true).then(resp => {
        this.institutions = resp
    })

  },
  updated () {
    this.setFolderPopupPosition()
    this.enableScreenReaderForAllContent()
    if(!this.isChannelDataLoaded){
      this.loadChannelSetup()
    }
  },
  methods: {
    ...mapActions([
      'constructSearchQuery',
      'loadUserJwt',
      'loadIsChannelWindowClosed',
      'showCourseSectionDropDown',
      'loadAllChannels',
      'loadQuickLinks',
      'loadPermission',
      'loadInstitutionDetail',
      'loadInstitutionPackage',
      'loadLogDashboardActivity',
      'loadAuthenticateWebWidget',
      'loadSaveProspectiveStudentProfile',
      'saveADASetting',
      'loadUserInfo',
      'setUserInfo',
      'setInpersonateUserInfo',
      'loadInpersonateUser',
      'resetRecompute',
      'loadMajorMinors',
      'loadNamedQueries',
      'loadLearnerDashboardState',
      'loadLearnerEnrollmentData',
      'loadLearnerEnrolledProgram',
      'loadForceResetTourElements',
      'loadChangeUserInstitution',
      'getAllUserAccountCount',
      'loadSelfRegistrationConfiguration',
      'loadUserTransactions',
      'loadAllUserInstitution',
      'loadAllChannels'
    ]),
    changeLanguage(lang) {
      this.$i18n.locale = lang; // Change the language dynamically
    },
    changeInstitution (institution) {
      this.loadChangeUserInstitution(institution.uuid).then(res => {
        this.$store.commit('LOAD_ALL_CHANNELS', [])
        this.$store.commit('LOAD_LEARNING_SPACES', [])
        let status = res.status
        let userObj = res.data
        this.loadAllChannels()
        if (status === 200) {
          this.setUserInfo(userObj)
          let userRole = userObj.roles[0].role
          let role = userRole.toLowerCase()
          this.navigateToDashboardIns(role)
        }
      })
    },
    navigateToDashboardIns (userRole) {
      let role = userRole.toLowerCase()
      let url = '/user/track/' + role
      if ((role === 'instructor & admin') || (role === 'curator')) {
        url = '/user/track/admin'
      } else if (role === 'employer admin') {
        url = '/employer/admin'
      } else if (role === 'prospective student' || role === 'admitted student') {
        url = '/user/track/' + role.split(' ').join('_')
      } else if (role === 'widget admin') {
        url = '/user/track/' + role.split(' ').join('_')
      }

      this.$router.push(url)
      setTimeout(() => {
        window.location.reload()
      }, 500)
    },
    updateForceTourElements () {
      this.loadForceResetTourElements(true)
    },
    partnerHomePage () {
        window.location.href = this.institution.partnerHomeUrl
    },
    showAskAdvisorModal () {
      if(this.getAskAdvisorExternalLink){
        window.open(this.getAskAdvisorExternalLink, '_blank')
      }else{
        this.$refs.loadingAskAdvisorModal.show()
      }
    },
    getQuickLinksLabel () {
      let quickLinks = this.enabledFeatures['quick_links']
      return quickLinks && quickLinks.label? quickLinks.label:'Quick Links'
    },

    launchQuickLink(url){
        window.open(url, '_blank')
    },
    showAllLink() {
      this.showLinkSize = this.links.length
    },
    showLimitedLink () {
      this.showLinkSize = 2
    },
    hideAskAdvisorPopup () {
      this.$refs.loadingAskAdvisorModal.hide()
    },
    showMyProgramsMenu () {
      this.myProgramsMenu = true
      //this.myProgramsMenu = !this.myProgramsMenu;
    },
    hideMyProgramsMenu () {
      this.myProgramsMenu = false
    },
    async submitAskAdvisor () {
      this.showSubmitAskAdvisorLoader = true
      let tUserObj = _.cloneDeep(this.userObj)
      tUserObj.firstName = this.prospectiveStudentProfile.firstName
      tUserObj.lastName = this.prospectiveStudentProfile.lastName
      tUserObj.primaryPhoneNumber = this.prospectiveStudentProfile.primaryPhoneNumber

      let res = await this.loadSaveProspectiveStudentProfile(tUserObj)
      if (res) {
        await this.loadUserInfo()
        this.notifySuccess('Successfully saved information.')
      } else {
        this.notifyFailure('Oops! Something went wrong. Try again.')
      }
      this.showSubmitAskAdvisorLoader = false
      this.$refs.loadingAskAdvisorModal.hide()
    },
    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },
    getQueryParamByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&')
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        let results = regex.exec(decodeURIComponent(url))
        if (!results || !results[2]) return ''
        return results[2].replace(/\+/g, ' ')
      },
    viewBookmarks () {
      return this.$router.push({ name: 'bookmarks' })
    },
    applyInstituteTheme (titleVal) {
      if (this.isClearlyNextPackageEnabled) {
        $('body').addClass('inst_theme_clearlyNext')
      }
      // let instTitle = titleVal.replace(/\s/g, '');
      // $('body').addClass(instTitle)
    },
    applyUserRoleClass () {
      if (this.isStudentLogin) {
        $('#app').addClass('usr_theme_stud')
      }
      if (this.isCoachLogin) {
        $('#app').addClass('usr_theme_coach')
      }
    },
    enableAdaComplianceCss () {
      $('body').addClass('enable_ada_theme')
      this.enableScreenReaderForAllContent()
      this.userObj.adaEnabled = true
      this.saveADASetting(this.userObj)
    },
    disableAdaComplianceCss () {
      $('body').removeClass('enable_ada_theme')
      this.userObj.adaEnabled = false
      this.saveADASetting(this.userObj)
    },
    setADASetting () {
      if(this.userObj.adaEnabled){
        $('body').addClass('enable_ada_theme')
        this.enableScreenReaderForAllContent()
      }else{
        $('body').removeClass('enable_ada_theme')
      }
    },
    skipToPageContent () {
      $('.app_pg').attr('tabindex', 0)
      $('.app_pg').focus()
    },
    enableScreenReaderForAllContent () {
      $('.ace_sec').attr('tabindex', 0)
      $('.ace_sec_hd').attr('tabindex', 0)
      $('.ace_sec_txt').attr('tabindex', 0)
      $('.nav-link').attr('tabindex', 0)
    },
    showSearchBar () {
      this.isSearchBarEnabled = true
      //$('.header_search_container').toggle('slide', right, 5000);
      $('.discover_section_inner').animate({
        width: 'toggle'
      })
      $('.search_global').animate({
        width: 'toggle'
      })
      $('.input-search').focus()
    },
    hideSearchBar () {
      $('.discover_section_inner').animate({
        width: 'toggle'
      })
      $('.search_global').animate({
        width: 'toggle'
      })
      this.isSearchBarEnabled = false
    },
    disableScreenReaderForAllContent () {
      $('.ace_sec').attr('tabindex', -1)
      $('.ace_sec_hd').attr('tabindex', -1)
      $('.ace_sec_txt').attr('tabindex', -1)
    },
    navigateToDashboard () {
      this.loadLogDashboardActivity({action: 'clickHome', page: '', link: 'Home Icon'})
      return this.$router.push({ name: this.dashboardName })
    },
    setFolderPopupPosition () {
      var length = $('.course_search_dropdown').children().length
      if (length === 0) {
        $('.discover_section').addClass('folder-setting-popup-position')
      } else {
        $('.discover_section').removeClass('folder-setting-popup-position')
      }
    },
    loadChannelSetup () {
      // Special case: Check token before calling because this code could be triggered without a token
      if (this.isChannelEnabled && localStorage.getItem('token')) {
        this.loadUserJwt().then(res => {
          auth.signInWithCustomToken(res).then(result => {
            this.loadAllChannels().then(data => {
              this.isUserAuthenticatedOnFirebase = true
              this.isChannelDataLoaded = true
            })
          })
        })
      }
    },
    navigateToSearchResults () {
      let currentPath = this.$router.currentRoute.fullPath
      if (currentPath.startsWith('/advancedSearch/course')) {
        return this.$router.push({ name: 'courseSearchResults', params: {timestamp: new Date().getTime()} })
      } else if (currentPath.startsWith('/advancedSearch/catalog')) {
        return this.$router.push({name: 'catalogSearchResults', query: {_: new Date().getTime()}})
      } else if (this.$router.currentRoute.path === '/search/result') {
        return this.$router.push({name: 'tagSearchResults', query: {_: new Date().getTime()}})
      }
      this.isShowFolderSettingPopup = false
      this.$refs.courseSearch.resetSelectedTags()
      this.$router.push({name: 'results', query: {_: new Date().getTime()}})
      this.constructSearchQuery({ terms: this.searchTerm, pageNumber: 1, from: 0, isResetSelectedItems: true })
    },
    viewChannel () {
      this.loadIsChannelWindowClosed(false)
      // mark the current channel as read of this user
      db.ref('channels/' + this.currentChannel + '/unread/' + this.userObj.uuid).remove()
      setTimeout(() => {
        var msgSectionHeight = $('.msg_section_inner').innerHeight()
        $('.msg_row_section').scrollTop(msgSectionHeight)
      }, 100)
    },
    navigateToChannel () {
      return this.$router.push({name: 'courseSectionChannel', params: {uuid: this.userUuid, channelType: 'ALL'}})
    },
    populateLibraryFromPreferences () {
      let uObj = this.userObj
      if (uObj.userPreferences === undefined) {
        uObj = JSON.parse(localStorage.getItem('userobj'))
      }
      let preferences = uObj.userPreferences
      this.selectedFolders = preferences.learningSpaces
      this.doNotOpenFolderSettingAutomatically = preferences.doNotOpenDiscoverySettingsAutomatically
      return true
    },

    stopActing () {
        // Track stop inpersonating
        this.loadLogDashboardActivity({action: 'stopInpersonating', page: 'stopInpersonating', link: ''})
        this.loadInpersonateUser(localStorage.getItem('inpersonatingUser')).then(res => {
          let status = res.status
          let userObj = res.data
          if (status === 200) {
              this.setUserInfo(userObj)
              this.setInpersonateUserInfo(userObj)
              let userRole = userObj.roles[0].role
              let role = userRole.toLowerCase()
              this.navigateBackToDashboard(role)
          }
        })
    },
    navigateBackToDashboard (userRole) {
        let role = userRole.toLowerCase()
        let url = '/user/track/' + role
        if ((role === 'instructor & admin') || (role === 'curator')) {
          url = '/user/track/admin'
        } else if (role === 'employer admin') {
          url = '/employer/admin'
        } else if (role === 'prospective student' || role === 'admitted student') {
          url = '/user/track/' + role.split(' ').join('_')
        } else if (role === 'widget admin') {
          url = '/user/track/' + role.split(' ').join('_')
        }
        this.$router.push(url)
        setTimeout(() => {
            window.location.reload()
          }, 500)

    },
    toggleFolderSettingPopup () {
      let currentPath = this.$router.currentRoute.fullPath
      if ((currentPath.startsWith('/advancedSearch/course')) || (currentPath.startsWith('/advancedSearch/catalog'))) {
        return this.showCourseSectionDropDown({lastUpdatedTime: new Date()})
      } else if (this.$router.currentRoute.path === '/search/result') {
        this.$refs.courseSearch.openTagSearchPopup()
      } else {
        let isAllSearch = (this.$refs.courseSearch.dropDownText === 'All')
        if (isAllSearch) {
          if (!this.isShowFolderSettingPopup) {
            this.populateLibraryFromPreferences()
          }
          this.isShowFolderSettingPopup = !this.isShowFolderSettingPopup
        } else {
          this.showCourseSectionDropDown({lastUpdatedTime: new Date()})
        }
      }
    },
    keydownEvent (event) {
      let isAllSearch = (this.$refs.courseSearch.dropDownText === 'All')
      if (!this.isShowFolderSettingPopup && isAllSearch) {
        let res = this.populateLibraryFromPreferences()
        if (res) {
          var keyCode = (event.which ? event.which : event.keyCode)
          if (keyCode === 9 || keyCode === 13 || keyCode === 27) {
            this.isShowFolderSettingPopup = false
          } else if (!this.doNotOpenFolderSettingAutomatically) {
            this.isShowFolderSettingPopup = !this.doNotOpenFolderSettingAutomatically
          }
        }
      }
    },
    afterFolderSettingPopupShown () {
      this.focusRef(this.$refs.searchBox)
    },
    afterCourseSearchDropdownShown () {
      this.focusRef(this.$refs.searchBox)
    },
    focusRef (ref) {
      this.$nextTick(() => {
        this.$nextTick(() => { (ref.$el || ref).focus() })
      })
    },
    checkForAdvancedSearch () {
      let currentPath = this.$router.currentRoute.fullPath
      if ((currentPath.startsWith('/advancedSearch/course')) || (currentPath.startsWith('/advancedSearch/catalog'))) {
        this.showCourseSectionDropDown({lastUpdatedTime: new Date()})
      } else if (this.$router.currentRoute.path === '/search/result') {
        this.$refs.courseSearch.openTagSearchPopup()
      }
    },
    updateSearchTerm (event) {
      this.searchTerm = event
    },
    getClearlyNextPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getClearlyNextPackage(packages)
    },
    getEnrolledPrograms (){
        if(this.learnerDashboardState.enrollInProgram){
          return this.loadLearnerEnrolledProgram()
        }else{
          return []
        }
    },
    showMyPrograms (){
        alert('This will show sub menu for programs')
    },
    showProgramHome (code){
        localStorage.setItem('dashboardProgram', code)
        var routerParams = {}
 //       this.myProgramsMenu = false
        return this.$router.push({name: 'modernDashboard', params: routerParams, query: {code: code}})
    },

    navigateToLearnerProgram () {
      if (this.learnerDashboardState.enrollInProgram) {
        this.loadLearnerEnrolledProgram().then(programGuide => {
          this.navigateToProgramStatus(programGuide)
        })
      } else {
        this.pageToRedirect = 'INTRO'
        this.showCourseMessage = false
        this.$refs.noEnrolledProgramModal.show()
      }
    },
    navigateToLearnerCourses () {
      if (this.learnerDashboardState.enrollInProgram) {
        this.loadLearnerEnrolledProgram().then(programGuide => {
          this.navigateToProgramRequirement(programGuide)
        })
      } else {
        this.pageToRedirect = 'REQUIREMENT'
        this.showCourseMessage = true
        this.$refs.noEnrolledProgramModal.show()
      }
    },
    async populateNamedQueries () {
      let namedQueries = await this.loadNamedQueries()
      if (namedQueries && namedQueries.length > 0) {
        this.$store.commit('LOAD_NAMED_QUERY_ENABLED', true)
      } else {
        this.$store.commit('LOAD_NAMED_QUERY_ENABLED', false)
      }
    },
    async populateDashboardState () {
      if(this.isStudentLogin) {
        await this.loadLearnerDashboardState()
        this.learnerEnrollmentData = await this.loadLearnerEnrollmentData()
      }
      this.institutionCount = await this.getAllUserAccountCount()
    },
    async populateInterestedPrograms () {
      let result = await this.loadMajorMinors({page: 0, count: 5000, name: '', skipMinor: false})
      this.interestedPrograms = result.content.sort((a, b) => (a.name >= b.name) ? 1 : -1)
    },
    programInterestFormattedDisplay (item) {
      return item.name
    },
    afterProgramInterestSelected (item) {
      this.selectedProgramInterest = item.selectedObject
      this.$refs.programInterestAutocomplete.clear()
    },
    cancelNoEnrolledProgramModal () {
      this.pageToRedirect = ''
      this.selectedProgramInterest = {}
      this.$refs.noEnrolledProgramModal.hide()
    },
    navigateToSelectedProgramInterest () {
      if (this.pageToRedirect === 'INTRO') {
        this.navigateToProgramIntro(this.selectedProgramInterest)
      } else {
        this.navigateToProgramRequirement(this.selectedProgramInterest)
      }
      this.cancelNoEnrolledProgramModal()
    },
    navigateToProgramIntro (programGuide) {
      let routerParams = {
        cipCode: programGuide.cipCode,
        programGuideCode: programGuide.code,
        type: programGuide.type,
        returnTo: 'learnerDashboard',
        showBackToResultButton: true
      }
      return this.$router.push({name: 'programGuideIntroduction', params: routerParams, query: {returnTo: 'learnerDashboard'}})
    },
    navigateToProgramStatus (programGuide) {
      let routerParams = {
        cipCode: programGuide.cipCode,
        programGuideCode: programGuide.code,
        type: programGuide.type,
        returnTo: 'learnerDashboard',
        showBackToResultButton: true
      }
      return this.$router.push({name: 'programGuideMyProgramStatus', params: routerParams, query: {returnTo: 'learnerDashboard'}})
    },
    closeLegendPopup () {
      this.$refs.legendModal1.$emit('close')
    },
    navigateToProgramRequirement (programGuide) {
      let routerParams = {
        cipCode: programGuide.cipCode,
        programGuideCode: programGuide.code,
        type: programGuide.type,
        returnTo: 'learnerDashboard',
        showBackToResultButton: true
      }
      return this.$router.push({name: 'programGuideDegreeRequirements', params: routerParams, query: {returnTo: 'learnerDashboard'}})
    },
    exploreProgramsClicked () {
      this.cancelNoEnrolledProgramModal()
      setTimeout(() => {
        return this.$router.push({name: 'exploreProgramGuideResults'})
      }, 0)
    },
    homePageClicked () {
      this.cancelNoEnrolledProgramModal()
      setTimeout(() => {
        return this.$router.push({name: 'learnerDashboard'})
      }, 0)
    },
    completeYourProfileClicked () {
      this.cancelNoEnrolledProgramModal()
      return this.$router.push({name: 'learnerProfile', params: {uuid: this.userObj.uuid}})
    }
  },
  watch: {
    '$route' (to, from) {
      setTimeout(() => {
        this.enableScreenReaderForAllContent()
      }, 2000)
    },
    userObj (newObj) {
      if (!this.isShowingTermAndCondition) {
        if (this.shouldLoadZendesk) {
          try {
            this.loadAuthenticateWebWidget()
          } catch (error) {
            console.error('loadAuthenticateWebWidget '+ error);
          }
        }
        this.loadChannelSetup()
      }
    }
  },
  computed: {
    ...mapState({
      'userObj': state => state.user.userObj,
      'permission': state => state.user.permission,
      'links': state => state.dashboard.quickLinks,
      'unreadValue': state => state.channel.unreadValue,
      'isChannelWindowClosed': state => state.channel.isChannelWindowClosed,
      'myChannels': state => state.channel.channels,
      'channelUnreadCount': state => state.channel.channelUnreadCount,
      'unreadCountState': state => state.channel.unreadCountState,
      'institution': state => state.institution.institution,
      'packages': state => state.institution.packages,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'isNamedQueriesEnabled': state => state.adviseeTracker.isNamedQueriesEnabled,
      'learnerDashboardState': state => state.dashboard.learnerDashboardState,
      'isTempUser': state => state.user.tempUser
    }),
    isWalletEnabled () {
      if (this.userTransactions && this.userTransactions.length > 0) {
        for (var i = 0; i < this.userTransactions.length; i++) {
          let item = this.userTransactions[i]
          if (item.subscriptionId !== "") {
            console.log("Subscription found")
            return true
          }
        }
      }
      return false
    },
    isShowingTermAndCondition () {
      return (this.$route.path === '/termsAndConditions')
    },
    isLearnerDashboardEnabled () {
      let learnerDashboardFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_LEARNER_DASHBOARD_FEATURE_ID]
      if (learnerDashboardFeature) {
        return learnerDashboardFeature.enabled
      }
      return false
    },
    isSelfRegistrationEnabled () {
      let showSelfRegLinkFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_SELF_REGISTRATION_LINK_FEATURE_ID]
      return showSelfRegLinkFeature && showSelfRegLinkFeature.enabled
    },
    isShowProgramsEnabled () {
      let showProgramsMenu = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_MY_PROGRAMS_MENU]
      return (showProgramsMenu && showProgramsMenu.enabled)
    },
    isCapsico (){
      let host = window.location.host
      if(host && (host.indexOf('capsicohealth') !=-1)){
        return true
      }
      return false
    },
    getMyProgramsLabel () {
      let showProgramsMenu = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_MY_PROGRAMS_MENU]
      return showProgramsMenu? showProgramsMenu.label:'My Programs'
    },
    userName () {
      return this.userObj.firstName
    },
    inPersonateMode () {
      return localStorage.getItem('inpersonatingUser') && localStorage.getItem('inpersonatingUser')!=='null'
    },
    isCustomAdmin (){
      return this.userObj.customAdmin
    },
    isSupervisor (){
      return this.userObj.customAdmin && this.userObj.customPermission && this.userObj.customPermission.supervisorRole
    },

    isNotCusomAdmin (){
      return !this.userObj.customAdmin
    },
    logoUrl () {
      if ( this.institution && this.institution.logo) {
        let getInstTitle = this.institution.title
        let setInstThemeClass = getInstTitle.replace(/\s/g, '')
        $('body').addClass(setInstThemeClass)
        return this.institution.logo
      } else {
        return 'https://pragya2.s3.us-west-2.amazonaws.com/pragyaLogoSm.png'
      }
    },
    userProgramInterest () {
      return this.userObj.userProfile.programInterest
    },
    programInterestPlaceholder () {
      return (this.selectedProgramInterest.name || 'start typing program name')
    },
    isXprizeDataOptOutEnabled () {
      if (this.enabledFeatures && this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_XPRIZE_DATA_OPT_OUT]) {
        return this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_XPRIZE_DATA_OPT_OUT].enabled
      }
      return false
    },
    getDataOptOutLabel () {
      let label = "Learner Opt-out"
      if (this.enabledFeatures && this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_XPRIZE_DATA_OPT_OUT]) {
        label =  this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_XPRIZE_DATA_OPT_OUT].label
      }
      return label?label:"Learner Opt-out";
    },

    disableLegend () {
      var trole = this.user.state.userRole
      if (!trole) {
        trole = localStorage.getItem('userrole')
      }
      if (trole === 'Employer Admin') {
        return true
      } else {
        // check package whether legend is enabled
        let legendFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.LEGEND_FEATURE_ID]
        if (legendFeature && legendFeature.enabled) {
          return false
        }
        return true
      }
    },
    isZendeskEnabled () {
      let feature = this.enabledFeatures[PACKAGE.FEATURE_IDS.ZENDESK_FEATURE_ID]
      if (feature) {
        return feature.enabled
      }
      return true
    },
    usePragyaHelp () {
      return USE_PRAGYA_HELP === true
    },
    shouldLoadZendesk () {
      if (this.usePragyaHelp) {
        return false
      }
      return this.isZendeskEnabled
    },
    userRole () {
      return this.user && this.user.state && this.user.state.userRole
        ? this.user.state.userRole
        : localStorage.getItem('userrole')
    },
    getAskAdvisorExternalLink () {
      let askAdv = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_ASK_ADVISOR_ON_NAVIGATION]
      if (askAdv && askAdv.enabled) {
        let flags = askAdv.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === 'externalURL') {
            if(flag.enabled){
                return flag.label
            }
          }
        }
      }
      return false
    },

    isAskAdvisorEnabled () {
      let askAdvisorFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_ASK_ADVISOR_ON_NAVIGATION]
      if (askAdvisorFeature) {
        return askAdvisorFeature.enabled
      }
      return false
    },
    askAdvisorLabel () {
      let askAdvisorFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_ASK_ADVISOR_ON_NAVIGATION]
      if (askAdvisorFeature && askAdvisorFeature.enabled && askAdvisorFeature.label) {
        return askAdvisorFeature.label
      }
      return 'Ask Advisor'
    },
    isChannelEnabled () {
      let channelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CHANNELS_FEATURE_ID]
      if (channelFeature) {
        return channelFeature.enabled
      }
      return false
    },
    channelLabel () {
      let channelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CHANNELS_FEATURE_ID]
      if (channelFeature && channelFeature.label) {
        return channelFeature.label
      }
      return 'Channels'
    },
    isClearlyNextPackageEnabled () {
      let clearlyNextFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CLEARLY_NEXT_FEATURE_ID]
      if (clearlyNextFeature && clearlyNextFeature.enabled) {
        return true
      }
      return false
    },
    isExplorePackageEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_FEATURE_ID]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
    },
    isExploreProgramEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
    },
    isExploreCareerEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_CAREERS]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
    },
    exploreCareerLabel () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_CAREERS]
      if (exploreFeature && exploreFeature.label) {
        return exploreFeature.label
      }
      return this.$t('careersExplore')
    },
    exploreProgramLabel () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
      if (exploreFeature && exploreFeature.label) {
        return exploreFeature.label
      }
      return this.$t('programExplore')
    },
    isBookmarkEnabled () {
      let bookmarkFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.BOOKMARK_FEATURE_ID]
      if (bookmarkFeature && bookmarkFeature.enabled) {
        return true
      }
      return false
    },
    isAcceptPaymentsEnabled () {
      let acceptPayments = this.enabledFeatures[PACKAGE.FEATURE_IDS.PAYMENT_INTEGRATION]
      if (acceptPayments && acceptPayments.enabled) {
        return true
      }
      return false
    },
    isCalendarEnabled () {
      let calendar = this.enabledFeatures[PACKAGE.FEATURE_IDS.CALENDAR]
      if (calendar && calendar.enabled) {
        return true
      }
      return false
    },
    isJobBoardEnabled () {
      let jobBoard = this.enabledFeatures['Job Board']
      if (jobBoard && jobBoard.enabled) {
        return true
      }
      return false
    },
    isEmployerBoardEnabled () {
      let jobBoard = this.enabledFeatures['Job Board']
      if (jobBoard && jobBoard.enabled) {
        let flags = jobBoard.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === 'Employer Board') {
            return flag.enabled
          }
        }
      }
      return false
    },
    getEmployerBoardLabel () {
      let jobBoard = this.enabledFeatures['Job Board']
      if (jobBoard && jobBoard.enabled) {
        let flags = jobBoard.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === 'Employer Board' && flag.label) {
            return flag.label
          }
        }
      }
      return 'Employer Board'
    },
    getJobBoardLabel () {
      let jobBoard = this.enabledFeatures['Job Board']
      if (jobBoard && jobBoard.label) {
        return jobBoard.label
      }
      return 'Explore Job'
    },

    isMyProgressEnabled () {
      let programDetailFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
      if (programDetailFeature && programDetailFeature.enabled) {
        let flags = programDetailFeature.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === 'allowEnrollment') {
            return flag.enabled
          }
        }
      }
      return false
    },
    showTransferArticulationMappingUpload () {
      let transferCoursesFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TRANSFER_PREVIOUS_COURSES_FEATURE_ID]
      if (transferCoursesFeature && transferCoursesFeature.enabled) {
        let flags = transferCoursesFeature.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === 'showTransferArticulationMappingUpload') {
            return flag.enabled
          }
        }
      }
      return false
    },
    showProgressLegend () {
      // show progress legend
      let legendFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.LEGEND_FEATURE_ID]
      if (legendFeature && legendFeature.enabled) {
        let flags = legendFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showProgressLegend') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    showDashboardLegend () {
      // show dashboard legend
      let legendFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.LEGEND_FEATURE_ID]
      if (legendFeature && legendFeature.enabled) {
        let flags = legendFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showDashboardLegend') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    showCombinedLegend () {
      var uObj = this.userObj
      if (this.userObj.eMail === undefined) {
        uObj = JSON.parse(localStorage.getItem('userobj'))
      }
      if (uObj) {
        if (uObj.major1 !== undefined && uObj.major1 === 'CA') {
          return true
        }
      }
      return false
    },
    showProfilePopup () {
      if (!this.isStudentLogin) {
        return false
      }
      let profilePopupFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROFILE_FEATURE_ID]
      if (profilePopupFeature) {
        return profilePopupFeature.enabled
      }
      return false
    },
    isTourEnabled () {
      if (!this.isStudentLogin) {
        return false
      }
      let tourFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TOUR_FEATURE_ID]
      if (tourFeature) {
        return tourFeature.enabled
      }
      return false
    },
    currentChannel () {
      let routeName = this.$route.name
      if (this.myChannels.length > 0) {
        for (var i = 0; i < this.myChannels.length; i++) {
          if (this.myChannels[i].entityType === 'employer') {
            if (routeName === 'employerHome' || routeName === 'employerCategory' || routeName === 'jobHome' || routeName === 'jobApplicants' || routeName === 'jobViewers' || routeName === 'jobReports') {
              return this.myChannels[i].externalId
            }
          }
          if (this.myChannels[i].entityType === 'stream') {
            if (routeName === 'streamTime' || routeName === 'streamCategory' || routeName === 'streamProgress' || routeName === 'programGuide') {
              if (this.myChannels[i].entityId === this.$route.params.uuid) {
                return this.myChannels[i].externalId
              }
            }
          }
        }
        return this.myChannels[0].externalId
      }
    },
    currentChannelInformation () {
      let routeName = this.$route.name
      if (this.myChannels.length > 0) {
        for (var i = 0; i < this.myChannels.length; i++) {
          if (this.myChannels[i].entityType === 'employer') {
            if (routeName === 'employerHome' || routeName === 'employerCategory' || routeName === 'jobHome' || routeName === 'jobApplicants' || routeName === 'jobViewers' || routeName === 'jobReports') {
              return this.myChannels[i]
            }
          }
          if (this.myChannels[i].entityType === 'stream') {
            if (routeName === 'streamTime' || routeName === 'streamCategory' || routeName === 'streamProgress' || routeName === 'programGuide') {
              if (this.myChannels[i].entityId === this.$route.params.uuid) {
                return this.myChannels[i]
              }
            }
          }
        }
        return this.myChannels[0]
      }
    },
    username: function () {
      var tuser = this.user.state.userFullName
      console.log(tuser)
      if (this.tempUsername) {
        // DO NOT CHANGE THIS RETURN STATEMENT
        return this.user.state.userFullName
      } else {
        return localStorage.getItem('userFullName')
      }
    },
    userUuid () {
      if (this.tempUserObj.uuid) {
        return this.tempUserObj.uuid
      } else {
        return localStorage.getItem('userid')
      }
    },
    institutionUuid () {
      if (this.institution.uuid) {
        return this.institution.uuid
      }
      return localStorage.getItem('institutionId') || JSON.parse(localStorage.getItem('userobj')).institutionId
    },
    isStudentLogin: function () {
      var trole = this.user.state.userRole
      console.log(trole)
      if (this.tempUserRole) {
        // DO NOT CHANGE THIS RETURN STATEMENT
        return ((this.user.state.userRole === 'Student') || (this.user.state.userRole === 'Prospective Student') || (this.user.state.userRole === 'Admitted Student'))
      } else {
        return ((localStorage.getItem('userrole') === 'Student') || (localStorage.getItem('userrole') === 'Prospective Student') || (this.user.state.userRole === 'Admitted Student'))
      }
    },
    isInstructorLogin: function () {
        return ((localStorage.getItem('userrole') === 'Instructor'))
    },

    isProspectiveStudentLogin: function () {
      var trole = this.user.state.userRole
      console.log(trole)
      if (this.tempUserRole) {
        // DO NOT CHANGE THIS RETURN STATEMENT
        return (this.user.state.userRole === 'Prospective Student')
      } else {
        return (localStorage.getItem('userrole') === 'Prospective Student')
      }
    },
    isCoachLogin: function () {
      var trole = this.user.state.userRole
      console.log(trole)
      if (this.tempUserRole) {
        // DO NOT CHANGE THIS RETURN STATEMENT
        return (this.user.state.userRole === 'Coach')
      } else {
        return (localStorage.getItem('userrole') === 'Coach')
      }
    },
    enableCareerIdea () {
      if (Object.keys(this.enabledFeatures).length === 0) {
        return true
      }
      return false
    },
    isChannelReady: function () {
      var channelReady = this.channel.state.isChannelReady
      if (channelReady) {
        return true
      } else {
        return false
      }
    },
    isChannelAvailable: function () {
      return (this.myChannels && this.myChannels.length > 0)
    },
    isSandboxUser: function () {
      var uObj = this.userObj
      if (this.userObj.eMail === undefined) {
        uObj = JSON.parse(localStorage.getItem('userobj'))
      }
      if (uObj) {
        return this.sandboxUsers.includes(uObj.eMail)
      }
      return false
    },
    isAdminLogin: function () {
      var trole = this.user.state.userRole
      console.log(trole)
      if (this.tempUserRole) {
        // DO NOT CHANGE THIS RETURN STATEMENT
        return (this.user.state.userRole === 'Instructor & Admin')
      } else {
        return (localStorage.getItem('userrole') === 'Instructor & Admin')
      }
    },
    isAdvisor: function () {
        return (localStorage.getItem('userrole') === 'Advisor')
    },
    showSecondaryNavBar () {
      if (this.isClearlyNextPackageEnabled && (this.isStudentLogin || this.isCoachLogin)) {
        return false
      }
      return true
    },
    hideHomeLinkInClearlyNext () {
      if (!this.isStudentLogin) {
        return false
      }
      /*
      let userObj = this.userObj && this.userObj.uuid ? this.userObj : JSON.parse(localStorage.getItem('userobj'))
      if (userObj && userObj.stripeSubscriptionId) {
        return false
      }
      */
      return true
    },
    clearlyNextFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.CLEARLY_NEXT_FEATURE_ID
      let clearlyNextPackage = this.getClearlyNextPackage()
      return PackageUtil.getFlagsFromPackageFeature(clearlyNextPackage, featureId)
    },
    showAccountSubscription () {
      if (!this.isStudentLogin) {
        return false
      }
      let clearlyNextFlagMap = this.clearlyNextFlagMap
      if (!clearlyNextFlagMap || !clearlyNextFlagMap.showAccountSubscription) {
        return false
      }
      return clearlyNextFlagMap.showAccountSubscription.enabled
    },
    exploreProgramsLabel () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
      if (exploreFeature) {
        for (var i = 0; i < exploreFeature.flags.length; i++) {
          if (exploreFeature.flags[i].title === 'useProgramLongText') {
            if (exploreFeature.flags[i].isEnabled) {
              return exploreFeature.flags[i].label
            }
          }
        }
      }
      return 'program'
    },
    exploreProgramsLabelPlural () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
      if (exploreFeature) {
        for (var i = 0; i < exploreFeature.flags.length; i++) {
          if (exploreFeature.flags[i].title === 'useProgramLongText') {
            if (exploreFeature.flags[i].isEnabled) {
              return exploreFeature.flags[i].label + 's'
            }
          }
        }
      }
      return 'programs'
    },
    dashboardName () {
      let trole = this.userRole || localStorage.getItem('userrole')
      let userObj = this.userObj && this.userObj.uuid ? this.userObj : JSON.parse(localStorage.getItem('userobj'))
      let permission = userObj.permission || this.permission
      let userPermission = permission.userPermission
      if (permission.name === this.superAdminPermissionName) {
        return 'superAdminDashboard'
      } else if (userPermission.studentHomeView) {
        return this.isClearlyNextPackageEnabled ? 'clearlyNextStudentDashboard' : 'studentDashboard'
      } else if (userPermission.employerAdminHomeView) {
        return 'employerAdmin'
      } else if (userPermission.advisorHomeView) {
        return 'adviseeTracker'
      } else if (userPermission.observerHomeView) {
        return 'observerDashboard'
      } else if (userPermission.instructorHomeView) {
        if (userPermission.adminHomeView) {
          return (this.isNuNavLogin) ? 'nunavAdminDashboard' : 'adminDashboard'
        } else if (trole === 'Coach') {
          return 'coachDashboard'
        }
        return 'instructorDashboard'
      } else if (userPermission.recruiterHomeView) {
        return 'recruiterDashboard'
      } else if (userPermission.prospectiveStudentHomeView) {
        return 'prospectiveStudentDashboard'
      } else if (userPermission.admittedStudentHomeView) {
        return 'admittedStudentDashboard'
      } else if (userPermission.widgetAdminHomeView) {
        return 'widgetAdminDashboard'
      }
    }
  }
}
</script>
<style scoped>

  .logo {
    height: 40px;
    width: auto;
  }

  .secondary-nav {
    min-height: 80px;
  }

  .lg_blc {
    width: 30px;
    height: 30px;
    display: inline-block;
    margin: 0px 17px 0px 15px;
  }

  .status_row {
    display: flex;
    align-items: center;
    height: 45px;
    margin: 10px 0;
    min-width: 186.33px;
    font-size: 15px;
  }

  .mc_progress_bar_label {
    position: absolute;
    top: 8px;
    right: 120px;
    font-size: 14px;
    color: #FFF;
  }

  .mc_popover_progress_bar_label {
    position: absolute;
    top: 48px;
    right: 110px;
    font-size: 14px;
    color: #fff;
  }

  .dropdown-submenu {
    position: absolute;
    left: auto;
    right: 159px;
    top: 0;
    background: #fff;
    border-radius: 4px;
    border: 1px solid #d8d8d8;
    display:none;
  }

  .legend-section {
    height: 46px;
    display: flex;
    align-items: center;
    float:right;
  }

  .icon-help {
    margin-top: 4px;
    display: inline-block;
  }

  .tagging-btn {
    margin-top: 4px;
    background: none;
    transform: rotate(-90deg);
  }

  .tagging-icon {
    color: #157099;
    font-size: 30px;
  }

  .tagging-icon:hover {
    color: #b78b10;
  }

  .cal-event-btn {
    background: none;
    margin: 0px 6px 2px -4px;
  }

  .cal-event-list-icon {
    color: #157099;
    font-size: 30px;
  }

  .cal-event-list-icon:hover {
    color: #b78b10;
  }

  .ico-program {
    font-size: 25px;
    margin-right: 6px;
  }

  .ico-course {
    color: #646464;
    font-size: 27px;
    margin-right: 10px;
  }

  .popup_head_txt {
    font-size: 1.4rem;
    font-weight: 600;
  }

  /* Pragya Help replaces Zendesk #launcher (was absolutely positioned; profile had 114px left margin) */
  .user-menu >>> .navbar-nav {
    align-items: center;
    flex-wrap: nowrap;
  }

  .user-menu >>> .btn_advisor {
    margin-top: 0;
    align-self: center;
    flex-shrink: 0;
  }

  .user-menu >>> .platform-advisor-nav-item {
    display: flex;
    align-items: center;
    padding: 0;
    margin: 0;
  }

  .user-menu >>> .user_menu_dropdown.user_menu_dropdown--pragya-help {
    margin-left: 8px !important;
  }

  .user-menu >>> .platform-help-nav-item {
    display: flex;
    align-items: center;
    padding: 0;
    margin: 0 8px 0 0;
  }
  .ic-inst {
    margin-top:-5px;
  }

</style>



// WEBPACK FOOTER //
// src/app/navigation/components/Navigation.vue